<template>
    <div class="outerWrapper">
        <div style="" class="textbox">
            <localized-string class="pageTitle" val="nearby.title"/>
            <div class="kennelGrid">
                <div class="kennelWrapper"  v-for="kennel in kennels"  v-bind:key="kennel.name">
                    <div class="kennelLogo">
                        <a :href="kennel.website">
                            <img :src="kennel.logo"/>
                        </a>
                        <span class="kennelNameLogo">
                        <a :href="kennel.website">{{kennel.name}}</a>
                    </span>
                    </div>
                    <div class="name kennelNameColumn">
                        <a :href="kennel.website">{{kennel.name}}</a>
                    </div>

                    <div class="description" v-html="kennel.description">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style lang="scss">
    $kennelsLogoSize: 8em;
    .pageTitle {
        font-size: 36px;
        font-weight: 600;
        margin-bottom: 0.5em;
    }
    div.outerWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        //height: 100%;
        width: auto;
    }
    .textbox {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255,255,255,0.95);
        margin: 1em 0;
        padding: 0.5em;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
        max-width: 1024px;
        display:flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
    }
    .kennelGrid {
        display: grid;
        grid-template-columns:  auto auto auto;
        grid-template-rows:  auto;
        grid-column-gap: 2em;
        grid-row-gap: 2em;
        align-content: start;
        justify-content: center;
        justify-items : center;
        align-items: center;
        padding: 1em 0.5em;
    }
    .kennelWrapper {
        display: contents;
    }
    .kennelLogo {
        grid-column: 1 /2;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
            width: $kennelsLogoSize;
            height: $kennelsLogoSize;

        }
        .kennelNameLogo {
            display: none;
            font-weight: 700;
            a {
                text-decoration: none;
            }
        }
    }

    .name {
        grid-column: 2 /3;
    }

    .description {
        grid-column: 3 /4;
        font-size: 14px;
        line-height: 1.4;
        justify-self: start;
    }

    .website {
        grid-column: 4 /5;

    }
    @media only screen and (max-width: 720px) {
        .textbox {
            margin: 0;
        }
        .name {
            grid-column: none;
            display: none;
        }
        .kennelLogo {
            img {
                width: 5em;
                height: 5em;
            }
            .kennelNameLogo {
                display: initial;
            }
        }
        .description {
            grid-column: 2 /4;

        }
    }
    @media only screen and (max-width: 71120px) {
        .name {
            grid-column: none;
            display: none;
        }
        .kennelLogo {
            .kennelNameLogo {
                display: initial;
                margin-top: 0.25em;
                font-size: 1.25rem;
            }
        }
        .description {
            grid-column: 2 /4;
        }
    }

      @media only screen and (min-width: 960px) {
          .kennelGrid {
              align-items: start;
          }
          .kennelWrapper {
              margin-top: 1em;
              display: initial;
              .kennelNameLogo {
                  margin-top: 0.75em;
                  margin-bottom: 0.5em;
                  font-weight: 700;
                  font-size: 1.35rem;
              }
              .description {
                  margin-top: 0.5em;
              }
          }
      }

</style>


<script>
  import LocalizedString from "../components/localizedString";
  export default {
    name: 'LocalKennels',
    components: {LocalizedString},
    computed: {
      kennels() {
        if (this.$strings === "beaver") {
          return this.beaverKennels;
        } else {
          return this.demoKennels;
        }
      }
    },
    data() {
      return {
        beaverKennels: [
          {
            name: "Boston H3",
            website: "http://www.bostonhash.com/",
            description: "The original Boston Hash. Over 40 years old, though you can't say the same about most of its members. Runs Sunday afternoon October - April, and Wednesday Evenings April - October. 3-5 miles. Accessible by public transit. Not enough penguins.",
            logo: require("../assets/bostonh3logo.jpg")
          },
          {
            name: "Boston Moon H3",
            website: null,
            description: "Plentiful but terrible beer, a fence climb, and an outdoor circle. Bring a cranium cover, or suffer the consequences. Runs once a month, on nights when the moon is orbiting the Earth. 3-5ish miles. Schedule is on Boston's <a href='http://www.bostonhash.com/calendar'>calendar</a>. Accessible by public transit.",
            logo: null//require("../assets/b3h4.webp")
          },
          {
            name: "Ballbuster H4",
            website: null,
            description: "If you like running and penguins, this is the hash for you. Runs Saturday morning, usually on the third Saturday. Check the <a href='http://www.bostonhash.com/calendar'>calendar</a>. Usually accessible by public transit. Minimum length: 6.9 miles. Unfortunately, there is no maximum.",
            logo: require("../assets/b3h4.webp")
          },
          {
            name: "Pooflingers H3",
            website: "http://poofh3.com/",
            description: "Short and shiggy kennel which runs throughout New England. Car and seaplane accessible. Has trail almost as infrequently as Beaver.",
            logo: require("../assets/poofh3.webp")
          },
          {
            name: "Pink Taco H3",
            website: null,
            description: "Boston's ladies-only Hash. Info usually on the <a href='http://www.bostonhash.com/calendar'>calendar</a>.",
            logo: null//require("../assets/b3h4.webp")
          },
          {
            name: "Rhode Island H3",
            website: "https://rih3.com/",
            description: "The only punctual kennel in new England, RIH3 leaves every Monday night at 6:30PM SHARP. Check their website for details, which they usually post sometime late Sunday night. 3 to 5 miles.",
            logo: require("../assets/rih3.gif")
          },
          {
            name: "Northboro H3",
            website: "https://www.northboroh3.com/",
            description: "Hashing in the suburbs. 3-6 miles, with 2 or more drink checks. Once a month, usually on the weekend.",
            logo: null//require("../assets/b3h4.webp")
          },
          {
            name: "Happy Valley H3",
            website: null,
            description: "",
            logo: null//require("../assets/b3h4.webp")
          }

        ],
        demoKennels: [
          {
            name: "Jedi Order",
            website: "https://starwars.fandom.com/wiki/Jedi_Order",
            description: "Powerful Force-wielders and adjudicators tasked by the Galactic Republic to be the guardians of peace and order in the Star Wars galaxy; they defend and protect all sapient life, never attack. -Wikipedia",
            logo: require("../assets/jedi.png")
          },
          {
            name: "Alliance to Restore the Republic",
            website: "https://starwars.fandom.com/wiki/Alliance_to_Restore_the_Republic",
            description: "A stateless interstellar coalition of republican dissidents, revolutionary factions and anti-imperialist clandestine cell systems in a resistance movement against the imperialist Galactic Empire. The Alliance's goal is to restore the Galactic Republic. -Wikipedia",
            logo: require("../assets/rebel.png")
          },
          {
            name: "First Galactic Empire",
            website: "https://starwars.fandom.com/wiki/Galactic_Empire",
            description: "The Galactic Empire ruled for years through fear, intimidation, and tyranny. With a mighty military force including stormtroopers, spy technology like probe droids, and the planet-destroying Death Star, Emperor Palpatine’s regime seemed unstoppable and permanent. But some dared to strike back… - starwars.com",
            logo: require("../assets/empire.svg")
          },
          {
            name: "United Federation of Planets",
            website: "https://memory-alpha.fandom.com/wiki/United_Federation_of_Planets",
            description: "\"A dream that became a reality and spread throughout the stars.\"\n" +
              "– James T. Kirk, 2269",
            logo: require("../assets/federationofplanets.png")
          },
          {
            name: "Starfleet",
            website: "https://memory-alpha.fandom.com/wiki/Starfleet",
            description: "\"The first duty of every Starfleet officer is to the truth. Whether it's scientific truth, or historical truth, or personal truth. It is the guiding principle upon which Starfleet is based.\"\n" +
              "– Captain Jean-Luc Picard, 2368 (\"The First Duty\")",
            logo: require("../assets/starfleet.png")
          },
          {
            name: "Klingon Empire",
            website: "https://memory-alpha.fandom.com/wiki/Klingon_Empire",
            description: "\"I will fight any battle, anywhere… for the Empire!\"\n" +
              "– Martok, 2375 (\"Tacking Into the Wind\")",
            logo: require("../assets/klingon.png")
          },
        ]
    };
    }
  }
</script>
